import React, { useEffect, useState } from 'react'
import './SpinnerOverlay.scss'
import PropTypes from 'prop-types'

const SpinnerOverlay = props => {
  const [shouldRender, setShouldRender] = useState(props.loading)
  const [activeClass, setActiveClass] = useState(props.loading ? 'active' : '')

  // Make sure the animation has time to fade in and out again, smooth transition
  useEffect(() => {
    if (props.loading) {
      setShouldRender(true)
      setTimeout(() => {
        setActiveClass('active')
      }, 400)
    } else {
      // Wait a bit to hide again
      setTimeout(() => {
        setActiveClass('')
        setTimeout(() => {
          setShouldRender(false)
        }, 400)
      }, 400)
    }
  }, [props.loading])

  if (!shouldRender) {
    return null
  }

  return (
    <div className={`spinner-overlay ${activeClass}`}>
      <div className="background" />
      <div className="spinner-container">
        <div className="sk-chase">
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
          <div className="sk-chase-dot"></div>
        </div>
      </div>
    </div>
  )
}

SpinnerOverlay.propTypes = {
  loading: PropTypes.bool.isRequired
}
export default React.memo(SpinnerOverlay)
